@if (loading) {
<div class="text-center font-bold text-m">Loading...</div>
} @else { @if (!loading && isTokenValid) { @if (passwordChanged) {
<h1>{{ "PASSWORD_UPDATED_RESET" | translate }}</h1>
<button class="btn w-full" routerLink="/login">
  {{ "LOGIN" | translate }}
</button>
} @else {
<h1>{{ "RESET_PASSWORD" | translate }}</h1>
<form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
  <div class="password relative">
    <input
      [type]="showNewPassword ? 'text' : 'password'"
      formControlName="password"
      [placeholder]="'PASSWORD' | translate"
    />
    <button
      class="showPassword block absolute w-[24px] h-[24px] top-[12px] right-[12px]"
      type="button"
      [ngClass]="{active: showNewPassword}"
      (click)="showNewPassword = !showNewPassword"
      (keyup)="onKeyUp($event, 'showNewPassword')"
      tabindex="0"
    >
      {{ "SEE_PASSWORD" | translate }}
    </button>
  </div>
  @if (resetPasswordForm.get('password')?.touched) { @if
  (resetPasswordForm.get('password')?.hasError('required')) {
  <div class="error">
    {{ "PASSWORD_REQUIRED" | translate }}
  </div>
  } }
  <div class="password relative">
    <input
      [type]="showNewConfirmPassword ? 'text' : 'password'"
      formControlName="confirm_password"
      [placeholder]="'CONFIRM_PASSWORD' | translate"
    />
    <button
      class="showPassword block absolute w-[24px] h-[24px] top-[12px] right-[12px]"
      type="button"
      [ngClass]="{active: showNewConfirmPassword}"
      (click)="showNewConfirmPassword = !showNewConfirmPassword"
      (keyup)="onKeyUp($event, 'showNewConfirmPassword')"
      tabindex="0"
    >
      {{ "SEE_PASSWORD" | translate }}
    </button>
  </div>
  @if (resetPasswordForm.get('confirm_password')?.touched) { @if (
  resetPasswordForm.get('confirm_password')?.hasError('required') ) {
  <div class="error">
    {{ "CONFIRM_PASSWORD_REQUIRED_RESET" | translate }}
  </div>
  } } @if (error) {
  <div class="error">
    {{ error.error.error | translate }}
  </div>
  }
  <button type="submit">{{ submitButtonText }}</button>
</form>
} } @else {
<h1>{{ "RESET_LINK_EXPIRED" | translate }}</h1>
} }
